import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { FormikFormField } from '@frontman/rt-protections-ui';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import Select from '@ramsey-design-system/select';
import { RootState } from '../../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { createSelectOptionSchema } from '../../schema';
import { Formik, Form } from 'formik';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function EmploymentStatusStep(): ReactElement {
  const dispatch = useDispatch();
  const { employmentStatus: employmentStatus } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('employment');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Just a Couple of Demographics"
          subHeader=" Remember, we'll just use this info to make recommendations for you."
        />
      </GrayCard>

      <CardPadding>
        <CardHeader
          header="What best describes your employment status?"
          subHeader=" Stay at home means you bring economic value to the household in such a
          way that your replacement would need to be like Mary Poppins! This
          determines your need for two types of coverage."
        />
        <Formik
          initialValues={{ employmentStatus }}
          onSubmit={onSubmit}
          validationSchema={createSelectOptionSchema('employmentStatus')}
        >
          <Form ref={formRef}>
            <FormikFormField<CoverageCheckupState>
              id="employmentStatus"
              name="employmentStatus"
              className="u-spacingBlockMd"
              inputComponent={Select}
              rdsAttributes={{ length: 'lg' }}
            >
              <option value="">Select an Option</option>
              <option value="employed_full_time">Employed full-time</option>
              <option value="employed_part_time">Employed part-time</option>
              <option value="self_employed">Self Employed</option>
              <option value="stay_at_home">Stay at home</option>
              <option value="retired">Retired</option>
              <option value="unemployed">Unemployed</option>
            </FormikFormField>
            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { EmploymentStatusStep };
